import React from "react";

export default function FilterSidebar({ filters, onChange, onSearch, onClear }) {
  const handleChange = (e) => {
    onChange({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div>
          <label style={{ 
            display: 'block', 
            fontSize: '0.9rem', 
            fontWeight: '600', 
            marginBottom: '0.5rem',
            color: 'var(--text-primary)'
          }}>
            Search
          </label>
          <input
            name="search"
            value={filters.search}
            onChange={handleChange}
            placeholder="Search by title, artist, or tags"
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid var(--border-color)',
              borderRadius: '8px',
              backgroundColor: 'var(--surface-color)',
              color: 'var(--text-primary)',
              fontSize: '0.9rem'
            }}
          />
        </div>
        
        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem' }}>
          <label style={{ 
            display: 'block', 
            fontSize: '0.9rem', 
            fontWeight: '600', 
            marginBottom: '0.5rem',
            color: 'var(--text-primary)'
          }}>
            Genre
          </label>
          <input
            name="genre"
            value={filters.genre}
            onChange={handleChange}
            placeholder="Hip Hop, Pop, Rock..."
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid var(--border-color)',
              borderRadius: '8px',
              backgroundColor: 'var(--surface-color)',
              color: 'var(--text-primary)',
              fontSize: '0.9rem'
            }}
          />
        </div>
        
        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem' }}>
          <label style={{ 
            display: 'block', 
            fontSize: '0.9rem', 
            fontWeight: '600', 
            marginBottom: '0.5rem',
            color: 'var(--text-primary)'
          }}>
            Mood
          </label>
          <input
            name="mood"
            value={filters.mood}
            onChange={handleChange}
            placeholder="Energetic, Chill, Dark..."
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid var(--border-color)',
              borderRadius: '8px',
              backgroundColor: 'var(--surface-color)',
              color: 'var(--text-primary)',
              fontSize: '0.9rem'
            }}
          />
        </div>
        
        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem' }}>
          <label style={{ 
            display: 'block', 
            fontSize: '0.9rem', 
            fontWeight: '600', 
            marginBottom: '0.5rem',
            color: 'var(--text-primary)'
          }}>
            BPM Range
          </label>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <input
              name="bpmMin"
              value={filters.bpmMin}
              onChange={handleChange}
              placeholder="Min"
              type="number"
              style={{
                flex: 1,
                padding: '0.75rem',
                border: '1px solid var(--border-color)',
                borderRadius: '8px',
                backgroundColor: 'var(--surface-color)',
                color: 'var(--text-primary)',
                fontSize: '0.9rem'
              }}
            />
            <input
              name="bpmMax"
              value={filters.bpmMax}
              onChange={handleChange}
              placeholder="Max"
              type="number"
              style={{
                flex: 1,
                padding: '0.75rem',
                border: '1px solid var(--border-color)',
                borderRadius: '8px',
                backgroundColor: 'var(--surface-color)',
                color: 'var(--text-primary)',
                fontSize: '0.9rem'
              }}
            />
          </div>
        </div>
        
        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem' }}>
          <label style={{ 
            display: 'block', 
            fontSize: '0.9rem', 
            fontWeight: '600', 
            marginBottom: '0.5rem',
            color: 'var(--text-primary)'
          }}>
            Duration (minutes)
          </label>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <input
              name="durationMin"
              value={filters.durationMin}
              onChange={handleChange}
              placeholder="Min"
              type="number"
              step="0.5"
              style={{
                flex: 1,
                padding: '0.75rem',
                border: '1px solid var(--border-color)',
                borderRadius: '8px',
                backgroundColor: 'var(--surface-color)',
                color: 'var(--text-primary)',
                fontSize: '0.9rem'
              }}
            />
            <input
              name="durationMax"
              value={filters.durationMax}
              onChange={handleChange}
              placeholder="Max"
              type="number"
              step="0.5"
              style={{
                flex: 1,
                padding: '0.75rem',
                border: '1px solid var(--border-color)',
                borderRadius: '8px',
                backgroundColor: 'var(--surface-color)',
                color: 'var(--text-primary)',
                fontSize: '0.9rem'
              }}
            />
          </div>
        </div>
        
        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem' }}>
          <label style={{ 
            display: 'block', 
            fontSize: '0.9rem', 
            fontWeight: '600', 
            marginBottom: '0.5rem',
            color: 'var(--text-primary)'
          }}>
            License Type
          </label>
          <select
            name="license"
            value={filters.license}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid var(--border-color)',
              borderRadius: '8px',
              backgroundColor: 'var(--surface-color)',
              color: 'var(--text-primary)',
              fontSize: '0.9rem'
            }}
          >
            <option value="">Any License</option>
            <option value="exclusive">Exclusive</option>
            <option value="non-exclusive">Non-Exclusive</option>
            <option value="sync">Sync License</option>
            <option value="royalty-free">Royalty Free</option>
          </select>
        </div>
      </div>
      
      <div style={{ 
        display: 'flex', 
        gap: '0.75rem', 
        paddingTop: '1rem', 
        borderTop: '1px solid var(--border-color)' 
      }}>
        <button
          type="button"
          onClick={onSearch}
          className="professional-button"
          style={{ 
            flex: 1, 
            padding: '0.75rem 1rem',
            fontSize: '0.9rem',
            fontWeight: '600'
          }}
        >
          🔍 Apply Filters
        </button>
        <button
          type="button"
          onClick={onClear}
          className="professional-button professional-button-secondary"
          style={{ 
            flex: 1, 
            padding: '0.75rem 1rem',
            fontSize: '0.9rem',
            fontWeight: '600'
          }}
        >
          🗑️ Clear All
        </button>
      </div>
    </div>
  );
}

